<footer class="footer text-primary d-flex justify-content-center align-items-center mt-5">
  <div class="mx-3">Synapse 2025 © Tous droits réservés · Synapse est une filiale de Takima</div>
</footer>
